<template>
  <el-col :span="24" class="jom-body">
    <abstract v-if="ARTICLE.abstractgraphic || ARTICLE.abstracts"></abstract>
    <keyword v-if="ARTICLE.keyword"></keyword>
    <ocis v-if="ARTICLE.ocis"></ocis>
    <highlight v-if="ARTICLE.highlights && ARTICLE.highlights.length>0"></highlight>
    <div :class="{'justify-align' : ARTICLE.defaultlang == 'zh', 'left-align' : ARTICLE.defaultlang == 'en'}">
    <component :is="'jo' + item.name" v-for="item in body" v-bind:key="item.index" v-bind:data="item.data"></component>
    <response></response>
    <conandack></conandack>
    <supplementary v-if="ARTICLE.supplementary && ARTICLE.supplementary.length>0"></supplementary>
    <conflict></conflict>
    <ethics></ethics>
    <supportedby></supportedby>
    <glossary></glossary>
    <appendix v-if="ARTICLE.appendix && ARTICLE.appendix.length > 0"></appendix>
    <sub-article v-if="ARTICLE.subArticles"></sub-article>
    </div>
    <reference v-if="ARTICLE.reflist && ARTICLE.reflist.data.length > 0"></reference>
  </el-col>
</template>

<script>
import jofig from './fig/fig.vue'
import jodispformula from './formula/dispformula.vue'
import jotable from './table/table.vue'
import jofiggroup from './fig/figgroup.vue'
import jodispquote from './dispquote/dispquote.vue'
import abstract from './abstract/abstract.vue'
import keyword from './keyword/keyword.vue'
import ocis from './ocis/ocis.vue'
import response from './response/response.vue'
import glossary from './glossary/glossary.vue'
import reference from './reference/reference.vue'
import conandack from './conandack/conandack.vue'
import conflict from './conflict/conflict.vue'
import supportedby from './supportedby/supportedby.vue'
import appendix from './appendix/appendix.vue'
import supplementary from './supplementary/supplementary.vue'
import highlight from './highlight/highlight.vue'
import subArticle from '../../../commonComponents/subArticle.vue'
import ethics from '../../../commonComponents/ethics.vue'

export default {
  components: {
    jofig,
    jodispformula,
    jotable,
    jofiggroup,
    jodispquote,
    abstract,
    keyword,
    ocis,
    response,
    glossary,
    reference,
    conandack,
    conflict,
    supportedby,
    appendix,
    supplementary,
    highlight,
    subArticle,
    ethics
  },
  name: "jobody",
  data() {
    return {
      height: 0,
      body: []
    }
  },
  created() {
    this.body = this.ARTICLE.body
  }
}
</script>

<style lang="scss" scoped>
  .jom-body {
    position: relative;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/body.vue